import { HE_ONBOARDING_PROFILE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    profile: HEOnboardingProfile;
    error?: string;
}

export interface HEOnboardingProfile {
    docid?: string;
    isActivated?: boolean;
    lastStep?: string;
    isPharmaEnabled?: boolean;
    isLabEnabled?: boolean;
    bank_details?: BankDetails;
    pancard?: string;
    staff?: Staff[];
    activateInProfile?: boolean;
    isTrialOrderPlaced?: boolean;
}

export interface Staff {
    isAllowed?: boolean;
    staff_oid?: string;
    bank_details?: BankDetails;
    pancard?: string;
}

export interface BankDetails {
    beneficiary_name?: string;
    ifsc_code?: string;
    account_number?: string;
    upi_id?: string;
    account_type?: string;
    fund_acc_id?: string;
}

export default (): Promise<Response> =>
    fetchWithRefresh(HE_ONBOARDING_PROFILE).then((res) => res.json());
